// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import React from 'react';
import { Card, Typography } from '@kintent/glide';

import * as Styles from './Statement.styles';
import { useProgramContent } from '../../../../../lib/state';

function Statement() {
  const [{ statementPrimaryText = null, statementReferrerText = null, statementStyle }] = useProgramContent();

  const statementPrimaryTextStyle = statementStyle?.primary ?? {};
  const statementPrimaryReferrerTextStyle = statementStyle?.primaryReferrerTextStyle ?? {};

  return (
    <Styles.Section data-testid="statement-section">
      <Card className="statement-card">
        {statementPrimaryText && (
          <Typography
            as="h4"
            level="4"
            data-testid="statement-section-primary"
            className="statement-primary"
            style={statementPrimaryTextStyle}
          >
            {statementPrimaryText}
          </Typography>
        )}
        {statementReferrerText && (
          <Typography
            as="p"
            strength="60%"
            style={statementPrimaryReferrerTextStyle}
            dangerouslySetInnerHTML={{ __html: statementReferrerText }}
          />
        )}
      </Card>
    </Styles.Section>
  );
}

export default Statement;
